import { api } from './base-api';
import {
  CreateUsuarioPayload,
  PaginatedUsuarios,
  UpdatePermissionsPayload,
  UpdateUsuarioPayload,
  UsuarioInterno,
  UsuariosFilters,
} from '../../types/usuario';

const cleanParams = (filters: Record<string, unknown>) => {
  const result: Record<string, string | number | boolean> = {};
  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === null || value === '') continue;
    result[key] = value as string | number | boolean;
  }
  return result;
};

export interface ListUsuariosParams extends Partial<UsuariosFilters> {
  page?: number;
  limit?: number;
}

export const usuariosApi = {
  async list(params: ListUsuariosParams = {}): Promise<PaginatedUsuarios> {
    const { data } = await api.get<PaginatedUsuarios>('/admin/users', {
      params: cleanParams({ ...(params as Record<string, unknown>) }),
    });
    return data;
  },

  async detail(id: string): Promise<UsuarioInterno> {
    const { data } = await api.get<UsuarioInterno>(`/admin/users/${id}`);
    return data;
  },

  async create(payload: CreateUsuarioPayload): Promise<UsuarioInterno> {
    const { data } = await api.post<UsuarioInterno>('/admin/users', payload);
    return data;
  },

  async update(
    id: string,
    payload: UpdateUsuarioPayload,
  ): Promise<UsuarioInterno> {
    const { data } = await api.patch<UsuarioInterno>(
      `/admin/users/${id}`,
      payload,
    );
    return data;
  },

  async activate(id: string): Promise<UsuarioInterno> {
    const { data } = await api.patch<UsuarioInterno>(
      `/admin/users/${id}/activate`,
    );
    return data;
  },

  async deactivate(id: string): Promise<UsuarioInterno> {
    const { data } = await api.patch<UsuarioInterno>(
      `/admin/users/${id}/deactivate`,
    );
    return data;
  },

  async updatePermissions(
    id: string,
    payload: UpdatePermissionsPayload,
  ): Promise<UsuarioInterno> {
    const { data } = await api.put<UsuarioInterno>(
      `/admin/users/${id}/permissions`,
      payload,
    );
    return data;
  },
};
